import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import MaterialRadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
/**@param {import('./types').FormInputRadioGroupProps} props */

var RadioGroupInput = function RadioGroupInput(_ref) {
  var options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      label = _ref.label,
      disabled = _ref.disabled,
      control = _ref.control,
      labelPlacement = _ref.labelPlacement,
      row = _ref.row,
      rest = _objectWithoutProperties(_ref, ["options", "value", "onChange", "label", "disabled", "control", "labelPlacement", "row"]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var onFocus = function onFocus() {
    setFocused(true);
  };

  var onBlur = function onBlur() {
    setFocused(false);
  };

  var className = focused ? "Mui-focused" : "";
  return React.createElement(React.Fragment, null, React.createElement(FormControl, {
    component: "fieldset"
  }, React.createElement(MaterialRadioGroup, Object.assign({
    value: value,
    onChange: onChange,
    "aria-label": label,
    row: row,
    onBlur: onBlur,
    onFocus: onFocus,
    className: className
  }, rest), options.map(function (opt) {
    return React.createElement(FormControlLabel, {
      key: opt.value,
      value: opt.value,
      disabled: disabled,
      control: control,
      label: opt.label || opt.value,
      labelPlacement: labelPlacement
    });
  }))));
};

RadioGroupInput.defaultProps = {
  options: [],
  control: React.createElement(Radio, {
    color: "primary"
  }),
  labelPlacement: 'end',
  row: false
};
export default RadioGroupInput;